import React from 'react'
import { Pill } from '../../../../ui'

const CYCLE = [null, 'solo', 'team']

// Custom 2-colour categorical palette: encodes attribution
// (solo / team), not a status. The teal/lime tones don't map to any
// semantic Pill tone; the colours are passed via Pill's `style`
// override on top of the shared chip recipe. See
// docs/contributor/design-language.md §13.
const STYLES = {
  solo: { background: '#9FE1CB', color: '#04342C' },
  team: { background: '#C0DD97', color: '#173404' },
}

const PILL_OVERRIDE = {
  fontSize: 9,
  fontWeight: 500,
  padding: '2px 7px',
  maxWidth: 120,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}

export function AttributionToggle({ value = null, onChange, disabled = false }) {
  const next = () => {
    const idx = CYCLE.indexOf(value)
    onChange(CYCLE[(idx + 1) % CYCLE.length])
  }

  if (value == null) {
    return (
      <Pill
        as="button"
        type="button"
        tone="neutral"
        onClick={() => !disabled && next()}
        disabled={disabled}
        aria-label="Add attribution tag"
        style={{ ...PILL_OVERRIDE, background: 'transparent', color: 'var(--text-secondary)', opacity: 0.5 }}
      >
        + who?
      </Pill>
    )
  }

  return (
    <Pill
      as="button"
      type="button"
      tone="neutral"
      onClick={() => !disabled && next()}
      disabled={disabled}
      aria-label={`Attribution: ${value}. Click to change.`}
      style={{ ...PILL_OVERRIDE, ...STYLES[value] }}
    >
      {value}
    </Pill>
  )
}
